import useGetRequest from 'hooks/useGetRequest';
import { Course } from 'models/Course';
import { CourseScheduleOverview } from 'models/CourseScheduleOverview';
import React from 'react';

type TrainerDashboardContextValue = {
    courses: Course[];
    liveCourses: CourseScheduleOverview[];
    errors: boolean;
    refetchCourses: () => Promise<void>;

};

export const TrainerDashboardContext = React.createContext<TrainerDashboardContextValue>({
    courses: [],
    liveCourses: [],
    errors: false,
    refetchCourses: async () => {}
});

export function TrainerDashboardProvider(props: { children: React.ReactNode }): JSX.Element {

    const { data: courses, errors: coursesErrors, refetchData: refetchCourses } = useGetRequest<Course[]>('courses/user');

    const { data: liveCourses, errors: liveCourseErrors } =
        useGetRequest<CourseScheduleOverview[]>('courses/schedule');

    let errors: boolean = false;
    if (
        (coursesErrors && coursesErrors.length) ||
        (liveCourseErrors && liveCourseErrors.length)
    ) {
        errors = true;
    }

    if (!courses || !liveCourses) return <></>;

    return (
        <TrainerDashboardContext.Provider
            value={{
                courses: courses,
                liveCourses: liveCourses,
                errors: errors,
                refetchCourses: refetchCourses
            }}
        >
            {props.children}
        </TrainerDashboardContext.Provider>
    );
}
